import tribunalAPI from "../../api/tribunalAPi";
import { RegionesResponse } from "interfaces/demandas/demandasInterface";
import { JuzgadosConExpedienteResponse } from "interfaces/juzgadosConExpediente/juzgadosConExpedinte";

const getRegionesJuzgados = async () => {
    let url = "demandas/obtener/regiones";
    return await tribunalAPI.get<RegionesResponse>(url);
};

const getJuzgadosConExpediente = async () => {
    let url = `servicios-generales/juzgados-con-expediente-electronico`;
    return await tribunalAPI.get<JuzgadosConExpedienteResponse>(url);
};

const getJuzgadosIndicesService = async () => {
    let url = `/indices/juzgados`;
    return await tribunalAPI.get<JuzgadosConExpedienteResponse>(url);
};

export {
    getRegionesJuzgados,
    getJuzgadosConExpediente,
    getJuzgadosIndicesService
}